import React, { FC } from 'react';

import cx from 'classnames';
import sanityImgUtil from 'utils/sanityImgUtil';
import sanityImgSrcSetUtil from 'utils/sanityImgSrcSetUtil';

import { Img } from 'components/base';

import { EmphasizeModuleColorScheme } from 'constants/ColorScheme';

import { ArticleHero as IArticleHero } from 'types';

interface Props {
  hero: IArticleHero;
  title: string;
}

const ArticleHero: FC<Props> = ({ hero, title }) => {
  const { image, subtitle } = hero;
  const colorScheme = EmphasizeModuleColorScheme[hero.color];

  return (
    <div
      className={cx(
        `ArticleHero bg-color-${colorScheme.background} color-${colorScheme.text} px1_5 pb1_5 sm:px2_25 sm:pb2 flex flex-col justify-end`,
        {
          pt5: !image.id,
          pt2_5: image.id,
        }
      )}
    >
      <h1 className="ArticleHero__title text-xl md-up_text-xxl">{title}</h1>
      {subtitle && (
        <p className="mt1_25 sm:mt_75 text-sm md-up_text-md">{subtitle}</p>
      )}
      {image.id && (
        <div className="mt1_75 sm:mt1_5 sm:mt3_75 flex justify-center">
          <Img
            alt={image.alt}
            sizes="(maxWidth: 768px) 660px, (maxWidth: 1024px) 500px, 1024px"
            src={sanityImgUtil(image, 660)}
            srcSet={sanityImgSrcSetUtil(image, 660, 550, 1024)}
            preloadContainerClassName="ArticleHero__image-container"
            dimensions={image.metadata?.dimensions}
            crop={image.crop}
          />
        </div>
      )}
    </div>
  );
};

export default ArticleHero;
